import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    color: 'white',
    textAlign: 'center',
    padding: ['40px 0px 0px', '100px 0px 0px'],

    '.slick-track': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  /* Part 1 */
  part1Container: {
    marginBottom: ['0px', '100px'],
  },
  part1Title: {
    marginBottom: ['12px', '24px'],
    padding: ['0px 20px', 'initial'],
  },
  part1Subtitle: {
    marginBottom: ['26px', '74px'],
    padding: ['0px 20px', 'initial'],
    maxWidth: ['324px', '917px'],
    marginX: 'auto',
  },
  part1RepeaterContainer: {
    flexDirection: ['column', 'row'],
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  /* Part 2 */
  part2Container: {
    marginBottom: ['20px', '64px'],
  },
  part2Title: {
    marginBottom: ['20px', '48px'],
    padding: ['0px 20px', 'initial'],
  },
  part2VideoContainer: {
    margin: '0px auto',
    width: ['302px', '900px', '1000px', '1100px', '1312px'],
    height: ['149px', '445px', '494px', '544px', '649px'],
    backgroundColor: 'black.100',
    '*': {
      outline: 'none !important',
    },
  },
  part2ModalHeader: {
    justifyContent: 'flex-end',
    marginBottom: '10px',
  },
  part2ModalHeaderClose: {
    border: '0',
    backgroundColor: 'transparent',
    outline: 'none',
    ':hover': {
      cursor: 'pointer',
    },
  },
  part2ModalHeaderCloseImg: {
    width: '36px',
    height: '36px',
  },
  /* Part 3 */
  part3Container: {
    marginBottom: ['30px', '88px'],
  },
  part3Title: {
    marginBottom: ['10px', '45px'],
    padding: ['0px 20px', 'initial'],
  },
  part3SliderContainer: {
    margin: ['0px 25px 16px', '0px 0px 48px'],
    '*': {
      outline: 'none !important',
    },
    '.slider': {
      minHeight: ['50px', '100px'], // Set these values to avoid different heights while moving on slides
      '.slick-list': {
        padding: ['0 10px', 'inherit'],
      },
      '.slick-arrow': {
        width: '40px',
        height: '40px',
        '&:hover': {
          cursor: 'pointer',
        },
        '&.slick-prev, &.slick-next': {
          '&:before': {
            content: 'unset',
          },
          svg: {
            path: {
              stroke: 'white',
            },
            width: '40px',
            height: '40px',
          },
        },
        '&.slick-prev': {
          left: '-25px',
        },
        '&.slick-next': {
          right: '-25x',
        },
      },
    },
  },
  part3SlideChild: {
    height: ['40px', '80px'], // Set the maximum height here for every breakpoint
  },
  part3LogoContainer: {
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: 'calc(100% - 20px)',
    height: '100%',
    '> .gatsby-image-wrapper img': {
      objectFit: 'scale-down !important',
    },
  },
  part3Image: {
    maxHeight: '150px',
    width: '100%',
  },
  part3cta: {
    margin: '0 auto',
  },
  /* Part 4 */
  part4Container: {
    paddingBottom: ['60px', '160px'],
    '.slider': {
      '*': {
        outline: 'none !important',
      },
      '.slick-list': {
        '.slick-track': {
          '.slick-slide': {
            '> div': {
              padding: ['0px 10px', '0px 30px'],
            },
          },
        },
      },
      '.slick-arrow': {
        display: 'none !important',
      },
      '.slick-dots': {
        bottom: ['-25px', '-90px'],
        '> li': {
          '> button': {
            '&:before': {
              backgroundColor: 'grayMedium.100',
              borderRadius: '50%',
              color: 'transparent',
              opacity: 1,
              width: '9px',
              height: '9px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            },
          },
          '&.slick-active': {
            '> button': {
              '&:before': {
                backgroundColor: 'lavender.100',
              },
            },
          },
        },
      },
    },
  },
  part4CardContainer: {
    margin: '0 auto',
  },
};
